// extracted by mini-css-extract-plugin
export default {"appointment_booking":"AppointmentBookingBundle_appointment_booking__ZADXa"};